import { Outlet } from 'react-router';
import { useTranslation } from 'react-i18next';
import { useEffectiveAccess } from '@/lib/effectiveAccess';
import { WorkQualityTabs } from '../components/WorkQualityTabs';
import {
  VERANTWOORDING_ANKER,
  VerantwoordingProvider,
  useHeeftVerantwoording,
} from '../components/VerantwoordingAnker';
import { Toestandsmelding, ToestandsmeldingProvider } from '../components/Toestandsmelding';
import { workQualityTabs } from '../tabs';

/**
 * Story 4.1 — de schil van Werkkwaliteit: één kop, de tabbalk wanneer er iets te wisselen valt, en
 * de gekozen weergave eronder. Story 4.6 hangt er de skip-link naar de verantwoordingsvoet aan.
 *
 * De weergaven zelf zijn de stories 4.2 tot en met 4.5. Wat deze laag wél draagt is wie welke
 * weergaven ziet, en die beslissing staat op één plek zodat de tabbalk en de routebewaking niet uit
 * elkaar kunnen lopen.
 */
function Overslaan() {
  const { t } = useTranslation();
  const aanwezig = useHeeftVerantwoording();

  // Geen link zolang er niets is om heen te springen — een sprong die niets doet, is verwarrender
  // dan geen sprong.
  if (!aanwezig) return null;

  return (
    <a className="skip-to-section" data-testid="werkkwaliteit-overslaan" href={`#${VERANTWOORDING_ANKER}`}>
      {t('qa.overslaanNaarVerantwoording')}
    </a>
  );
}

export function WorkQualityLayout() {
  const { t } = useTranslation();
  const { permissions, role } = useEffectiveAccess();
  // CAP-6: een employee heeft alleen de eigenpagina "Mijn feedback", wat zijn sessie ook draagt: de
  // server laat hem niet verder, dus een tabbalk met meer weergaven zou alleen terugstuurlinks zijn.
  const isFeedbackOnly = role === 'employee';
  const tabs = isFeedbackOnly ? [] : workQualityTabs(permissions);

  return (
    <VerantwoordingProvider>
      <ToestandsmeldingProvider>
        <section className="min-w-0" data-testid="werkkwaliteit">
          {/* Blijft altijd staan, ook leeg: een levend gebied dat samen met zijn tekst verschijnt,
              wordt niet voorgelezen. */}
          <Toestandsmelding />
          <Overslaan />
          {/* Voor de rol employee is dit de pagina "Mijn feedback" (CAP-6), net als in het menu en het
              kruimelpad; wie een andere rol heeft ziet de kop van de hele module. */}
          <h1 className="mb-4 text-xl font-semibold text-[var(--foreground)]">{isFeedbackOnly ? t('qa.titleOwn') : t('qa.title')}</h1>
          {/* One view gets no tab bar (UX-DR2): a lone tab would announce that others exist. */}
          {tabs.length > 1 && <WorkQualityTabs tabs={tabs} />}
          <Outlet />
        </section>
      </ToestandsmeldingProvider>
    </VerantwoordingProvider>
  );
}
